import initSplitTitle from './utils/init-split-title';

document.addEventListener('DOMContentLoaded', () => {
  initSplitTitle();
});